export enum OFFER_ACTIONS {
  RESTORED = 'Restored',
  DELETED = 'Deleted',
  UPDATED = 'Updated',
  CREATED = 'Created',
}

export enum AFFILIATE_OFFER_LINK_STATUS {
  ACTIVE = 'ACTIVE',
  PENDING = 'PENDING',
  DISABLED = 'DISABLED',
  PENDING_PAUSE = 'PENDING PAUSE',
  PENDING_UNPAUSE = 'PENDING UNPAUSE',
  FAILED_UPDATE = 'FAILED_UPDATE',
  DELETING = 'DELETING',
}

export const AutomatedPayoutLabel = 'Automated Tiers';
export const AUTOMATED_PAYOUT_ID = -1000; // this is just for front end handling, not using in backend.
